<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pKmywd/tc-custom/9780830891849.jpg?1696032476710" alt="This image is the cover for the book Worship in the Way of the Cross"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Worship in the Way of the Cross
      </h1>
      <p class="bookDescription body article font2">
        <p>Too often worship is seen as just the music, an onstage performance that puts the spotlight on the worship leader. But worship is fundamentally an others-centered, self-giving act of service. Worship properly directed to God for his glory also results in the Christlike formation and transformation of both worship leaders and congregants. Worship leader and biblical scholar John Frederick unpacks the shape of worship in the way of the cross, where leaders act not as lords but as servants. With a mix of biblical exposition and practical insights, he explores a cruciform theology of worship: as the cross demonstrates the nature of God, worship in the way of the cross transforms us into the image of God who is love. Thus worshipers and worship leaders alike can come to embody the other-centered humility of Christ. This paradigm has implications for how worship leaders and pastoral staff relate to one another, and for renewing the artistic output of the church. In cruciform worship, we encounter the Son of God and embody the love of God. Discover how in worship we can empty ourselves for the transformation of others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Frederick
      </h2>
      
      <p class="authorDescription body article"><p><em>Galatians and Christian Theology</em><em>Ecclesia and Ethics</em><em>Yu-Gi-Oh! The Movie</em><em>Carmen Dei: Truth Within the Static</em></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?98f015fe